"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _scenicSpot = _interopRequireDefault(require("@/mixins/scenic-spot"));
var _scenicSpot2 = require("@/api/scenic-spot");
var _vuex = require("vuex");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  mixins: [_scenicSpot.default],
  //此js存放商品的部分函数方法
  data: function data() {
    return {
      form: {},
      title: '',
      options: [],
      options1: [],
      options2: [],
      props2: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false,
        checkStrictly: true
      },
      proTypedialogVisible: false,
      //门票新增弹窗
      rules: {
        image: [{
          required: true,
          message: '请上传门票图片',
          trigger: 'change'
        }],
        flatPattern: [{
          required: true,
          message: '请输入展示图地址',
          trigger: 'blur'
        }],
        sliderImages: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入门票名称',
          trigger: 'blur'
        }],
        intro: [{
          required: true,
          message: '请输入门票简介',
          trigger: 'blur'
        }],
        keyword: [{
          required: true,
          message: '请输入关键词',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入门票价格',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['merProductClassify'])),
  mounted: function mounted() {
    if (!localStorage.getItem('merProductClassify') && (0, _permission.checkPermi)(['merchant:product:category:cache:tree'])) this.$store.dispatch('product/getMerProductClassify');
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 获取核销人员
    getEmployee: function getEmployee() {
      var _this = this;
      this.options = [];
      this.options1 = [];
      this.options2 = [];
      (0, _scenicSpot2.employeeLstApi)().then(function (res) {
        console.log("222", res.list);
        if (res.list.length > 0) {
          res.list.forEach(function (item, index) {
            _this.options.push({
              label: item.name,
              value: item.uid
            });
          });
        }
      });
      (0, _scenicSpot2.limitListApi)().then(function (res) {
        if (res.list.length > 0) {
          res.list.forEach(function (item, index) {
            _this.options1.push({
              label: item.name,
              value: item.uid
            });
          });
        }
      });
      (0, _scenicSpot2.lreturnListApi)().then(function (res) {
        if (res.list.length > 0) {
          res.list.forEach(function (item, index) {
            _this.options2.push({
              label: item.name,
              value: item.uid
            });
          });
        }
      });
    },
    selectAllWeeks: function selectAllWeeks() {
      this.form.applicablePeriod = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
    },
    showEdit: function showEdit(row) {
      this.getEmployee();
      if (row) {
        this.title = '修改门票';
        Object.assign(this.form, JSON.parse(JSON.stringify(row)));

        // 兼容字符串或 JSON 字符串的 sliderImage
        if (typeof this.form.sliderImage === 'string') {
          if (this.form.sliderImage.startsWith('[')) {
            // 是 JSON 字符串格式的数组
            this.form.sliderImages = JSON.parse(this.form.sliderImage);
          } else {
            // 是单个 URL 字符串
            this.form.sliderImages = [this.form.sliderImage];
          }
        } else {
          this.form.sliderImages = [];
        }
        console.log(this.form);
      } else {
        this.title = '新增门票';
        // Object.assign(this.form, JSON.parse(JSON.stringify(defaultObj)))
        this.$set(this.form, {});
        console.log(this.form);
      }
    },
    //选择门票类型确定
    // 保存
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.$refs['formValidate'].validate(function (valid) {
        if (valid) {
          console.log(_this2.form);
          if (_this2.form.id) {
            (0, _scenicSpot2.ticketUpdateApi)(_this2.form).then(function (res) {
              _this2.proTypedialogVisible = false;
              _this2.$emit('success');
              _this2.$message.success('修改成功');
            });
          } else {
            (0, _scenicSpot2.ticketCreateApi)(_this2.form).then(function (res) {
              _this2.proTypedialogVisible = false;
              _this2.$emit('success');
              _this2.$message.success('新增成功');
            });
          }
        }
      });
    }
  }
};